export const serviceData = {
	base:{
		tips_1:' 中国有色金属行业环境产品声明（EPD）平台是由中国有色金属行业统筹指导，中国铝业集团有限公司等行业企事业单位共同参与、面向社会公众开放的公益性平台。中国有色金属行业批复依托中国有色金属工业技术开发与交流中心设立中国有色金属行业环境产品声明平台办公室（简称“平台办公室”或“办公室”），具体负责平台运维和日常事务。',
		tips_2:' 平台为相关组织提供EPD/CFP申请、第三方独立验证、EPD/CFP发布等服务。',
		flow:'EPD/CFP开发流程',
		flow_tips:'EPD/CFP开发包括以下流程：',
		flow_img: require('@/assets/img/service/flow.png')
	},
	steps:[
		{
			title:'步骤1：',
			name:'平台注册',
			tp_tips:'',
			step_img: require('@/assets/img/service/step.png'),
			imgs:[],
			bt_tips:'',
			icon: require('@/assets/img/service/1.png')
		},
		{
			title:'步骤2：',
			name:'开发申请',
			tp_tips:'注册完成后，EPD/CFP申请者可通过平台EPD/CFP-申请EPD/CFP模块填写企业信息和产品信息完成EPD/CFP开发申请。',
			step_img: require('@/assets/img/service/step_a.png'),
			imgs:[],
			bt_tips:'办公室负责审核EPD/CFP开发申请并确定产品或服务适用的PCR。如无适合的PCR，则进入PCR开发流程。',
			icon: require('@/assets/img/service/2.png')
		},
		{
			title:'步骤3：',
			name:'签订服务协议',
			tp_tips:'EPD申请者应通过平台下载《EPD/CFP技术服务协议》，填写盖章后以快递的方式寄送至“中国有色金属行业EPD平台办公室-北京市海淀区复兴路乙12号-（010）63971471”。完成合同签署后，EPD申请者需按照合同约定支付相应服务费。',
			step_img: '',
			imgs:[],
			bt_tips:'',
			icon: require('@/assets/img/service/3.png')
		},
		{
			title:'步骤4：',
			name:'指定验证机构',
			tp_tips:'合同签订完成后，由办公室向EPD/CFP申请者推荐平台准入的第三方验证机构。',
			step_img: '',
			imgs:[],
			bt_tips:'',
			icon: require('@/assets/img/service/4.png'),
			table:{
				title:'附表1 第三方验证机构名单',
				header:{
					num:'序号',
					companyName:"机构名称",
					tiem:'入驻时间',
					territory:"擅长领域"
				},
				tableData:[{
					num:'1',
					companyName:"中铝郑州有色金属研究院有限公司",
					tiem:'2024年6月5日',
					territory:"有色轻金属工艺技术及生命周期评价研究"
				},
				{
					num:'2',
					companyName:"昆明冶金研究院有限公司",
					tiem:'2024年6月5日',
					territory:"有色重金属工艺技术及生命周期评价研究"
				},
				{
					num:'3',
					companyName:"中国有色金属工业技术开发交流中心",
					tiem:'2024年6月5日',
					territory:"III型环境标志、LCA-CFP研究、企业环保诊断、ESG披露咨询"
				}]
			}
		},
		{
			title:'步骤5：',
			name:'上传数据资料',
			tp_tips:'EPD/CFP申请者通过“平台-资源-模板”或通过“我的申请”下载相应产品或服务的数据采集模板，填写并上传采集数据和相关证明材料。',
			step_img: '',
			imgs:[],
			bt_tips:'',
			icon: require('@/assets/img/service/5.png')
		},
		{
			title:'步骤6：',
			name:'独立验证',
			tp_tips:'平台委托平台批准的第三方验证机构，对EPD/CFP申请者提交的数据和相关证明材料开展公正、独立地验证。第三方验证机构名单见步骤4中的附表1。',
			step_img: '',
			imgs:[],
			bt_tips:'',
			icon: require('@/assets/img/service/6.png')
		},
		{
			title:'步骤7：',
			name:'编制报告',
			tp_tips:'验证通过后，由平台基于EPD/CFP申请者提交的数据和相关证明材料生成EPD/CFP报告，并由第三方验证机构确认EPD/CFP报告的准确性和完整性。',
			step_img: '',
			imgs:[],
			bt_tips:'',
			icon: require('@/assets/img/service/7.png')
		},
		{
			title:'步骤8：',
			name:'评审',
			tp_tips:'第三方验证机构将CNIA-EPD tool自动生成的EPD/CFP报告连同其他强制性信息一起提交给办公室，由办公室组织技术委员会进行评审。',
			step_img: '',
			imgs:[],
			bt_tips:'',
			icon: require('@/assets/img/service/8.png')
		},
		{
			title:'步骤9：',
			name:'注册发布',
			tp_tips:'EPD/CFP报告评审通过后，由办公室分配一个平台注册号，并在平台完成EPD/CFP报告中文版本（PDF版本）发布。',
			step_img: '',
			imgs:[],
			bt_tips:'如需其他服务，请与平台办公室联系： 18514468983、010-63971471。',
			icon: require('@/assets/img/service/9.png')
		},
	]
}